<div class="component text-center phone-update">
  <div class="phone-update-overlay"></div>
  <div class="card">
    <p [dir]="languageService.getDir()">{{ 'USER.PHONE_CHANGE.ENTER_PHONE_NUMBER' | translate }}</p>
    <form (submit)="onSubmit()" [formGroup]="phoneForm">
      <div class="input-group justify-content-end">
        <ngx-intl-tel-input
          [cssClass]="'form-control text-right'"
          [preferredCountries]="[CountryISO.Israel]"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [separateDialCode]="true"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
          [selectFirstCountry]="false"
          [selectedCountryISO]="CountryISO.Israel"
          [numberFormat]="PhoneNumberFormat.International"
          [phoneValidation]="true"
          [inputId]="'phone'"
          name="phone"
          formControlName="phone"></ngx-intl-tel-input>
      </div>
      <button type="submit" class="btn update-phone-button">{{ 'BUTTON.UPDATE' | translate }}</button>
      <button type="button" class="btn btn-light" (click)="cancel()">{{ 'BUTTON.CANCEL' | translate }}</button>
    </form>
  </div>
</div>
